import { actions } from './actions'

const initialState = {
  dhlDescripciones: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function dhlReducer(state = initialState, action) {
  switch (action.type) {
    case actions.DHL_DESCRIPCION_LOAD_REQUESTED:
      return {
        ...state,
        dhlDescripciones: { ...state.dhlDescripciones, data: null, loading: true },
      }
    case actions.DHL_DESCRIPCION_LOAD_SUCCEEDED:
      return {
        ...state,
        dhlDescripciones: {
          ...state.dhlDescripciones,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.DHL_DESCRIPCION_LOAD_FAILED:
      return {
        ...state,
        dhlDescripciones: { ...state.dhlDescripciones, loading: false, error: action.error },
      }
    default:
      return state
  }
}
